module.exports = __webpack_public_path__ + "d811fb197bd80934162f1b44242c6e0a.png";